/************************************************************
 * app-hooks.ts
 * Contiene los hooks de React para Sponsor, SEO, Banner,
 * Program y Blog, usando los servicios de app-services.ts
 ************************************************************/

import { useState, useEffect } from "react";
import { Pagination } from "../../../interfaces";
import { Sponsor, SEO, Banner, Program, Blog, HomePage } from "../../../models/db";
import { SponsorService, SEOService, BannerService, ProgramService, BlogService, ConfigurationService, CategoryService, HomeService, WebPageService } from "../../../services/fisioteduca/fisioteduca.service";
import { Configuration } from "../../../models/db/configuration";
import { get } from "http";
import { PageType, WebPage } from "../../../models/db/web-page";
// Se asume que ya tienes la interfaz Pagination en tu proyecto

// Ajustar ruta según dónde esté app-services.ts



// --------------------------------------------------------
// useSponsor
// --------------------------------------------------------
export const useSponsor = () => {
    const service = new SponsorService();

    const getSponsors = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {

        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getSponsorById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addSponsor = (sponsor: Sponsor) => {
        return new Promise<any>((resolve, reject) => {
            service.add(sponsor)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateSponsor = (sponsor: Sponsor) => {
        return new Promise<any>((resolve, reject) => {
            service.update(sponsor.id, sponsor)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const deleteSponsor = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };



    const manageImage = (imageAddList: any[], imageUpdateList: any[], deleteImageList: any[]) => {
        return new Promise<any>((resolve, reject) => {
            service.manageImage(imageAddList, imageUpdateList, deleteImageList)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
    return {
        getSponsors,
        getSponsorById,
        addSponsor,
        updateSponsor,
        deleteSponsor,
        manageImage

    };
};

// --------------------------------------------------------
// useSEO
// --------------------------------------------------------
export const useSEO = () => {
    const service = new SEOService();

    const getSEO = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getSEOById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addSEO = (seo: SEO) => {
        return new Promise<any>((resolve, reject) => {
            service.add(seo)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateSEO = (seo: SEO) => {
        return new Promise<any>((resolve, reject) => {
            service.update(seo.id, seo)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const deleteSEO = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const checkSpecificParam = (id: any, value: any, type: "title" | "reference" | "slug") => {
        return new Promise<any>((res, rej) => {
            service.checkSpecificParam({ id, value, param: type })
                .then((item: any) => {
                    if (item && item?.data && item.data?.success) {
                        res(item.data.exists);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })
        })
    }

    return {
        getSEO,
        getSEOById,
        addSEO,
        updateSEO,
        deleteSEO,
        checkSpecificParam
    };
};

// --------------------------------------------------------
// useBanner
// --------------------------------------------------------
export const useBanner = () => {
    const service = new BannerService();

    const getBanners = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getBannerById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addBanner = (banner: Banner) => {
        return new Promise<any>((resolve, reject) => {
            service.add(banner)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateBanner = (banner: Banner) => {
        return new Promise<any>((resolve, reject) => {
            service.update(banner.id, banner)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const deleteBanner = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    return {
        getBanners,
        getBannerById,
        addBanner,
        updateBanner,
        deleteBanner
    };
};

// --------------------------------------------------------
// useProgram
// --------------------------------------------------------
export const useProgram = () => {
    const service = new ProgramService();

    const getPrograms = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getProgramById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addProgram = (program: Program) => {
        return new Promise<any>((resolve, reject) => {
            service.add(program)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateProgram = (program: Program) => {
        return new Promise<any>((resolve, reject) => {
            service.update(program.id, program)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const deleteProgram = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };


    return {
        getPrograms,
        getProgramById,
        addProgram,
        updateProgram,
        deleteProgram,
    };
};

// --------------------------------------------------------
// useBlog
// --------------------------------------------------------
export const useBlog = () => {
    const service = new BlogService();

    const getBlogs = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getBlogById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addBlog = (blog: Blog) => {
        return new Promise<any>((resolve, reject) => {
            service.add(blog)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateBlog = (blog: Blog) => {
        return new Promise<any>((resolve, reject) => {
            service.update(blog.id, blog)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const deleteBlog = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };


    // /sponsor/manage-image

    return {
        getBlogs,
        getBlogById,
        addBlog,
        updateBlog,
        deleteBlog
    };
};


export const useConfiguration = () => {
    const service = new ConfigurationService();

    const getConfigurations = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getConfigurationById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addConfiguration = (configuration: Configuration) => {
        return new Promise<any>((resolve, reject) => {
            service.add(configuration)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateConfiguration = (configuration: Configuration) => {
        return new Promise<any>((resolve, reject) => {
            service.update(configuration?.id, configuration)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };



    return {
        getConfigurations,
        getConfigurationById,
        addConfiguration,
        updateConfiguration,

    };
};

export const useCategory = () => {

    const service = new CategoryService();

    const getCategories = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    const getCategoryById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    const addCategory = (category: any) => {
        return new Promise<any>((resolve, reject) => {
            service.add(category)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    const updateCategory = (category: any) => {
        return new Promise<any>((resolve, reject) => {
            service.update(category?.id, category)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    const deleteCategory = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }



    const autocomplete = () => {
        return new Promise<any>((resolve, reject) => {
            service.autocomplete()
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }


    return {
        getCategories,
        getCategoryById,
        addCategory,
        updateCategory,
        deleteCategory,
        autocomplete,
        autocompleteCategory: autocomplete
    }


}





// --------------------------------------------------------
// useProgram
// --------------------------------------------------------
export const useHomePage = () => {
    const service = new HomeService();

    const getHomePages = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getHomePageById = (id: string) => {
        return new Promise<any>((resolve, reject) => {
            service.getById(id)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const addHomePage = (program: HomePage) => {
        return new Promise<any>((resolve, reject) => {
            service.add(program)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateHomePage = (program: HomePage) => {
        return new Promise<any>((resolve, reject) => {
            service.update(program.id, program)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const deleteHomePage = (idList: number[] | string[], action: boolean) => {
        return new Promise<any>((resolve, reject) => {
            service.delete(idList, action)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };


    return {
        getHomePages,
        getHomePageById,
        addHomePage,
        updateHomePage,
        deleteHomePage,
    };
};


// --------------------------------------------------------
// useWebPage
// --------------------------------------------------------
export const useWebPage = () => {
    const service = new WebPageService();

    const getWebPage = (pagination: Pagination = { page: 1, itemsPerPage: 5 }) => {
        return new Promise<any>((resolve, reject) => {
            service.getAll(pagination)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };


    const addWebPage = (program: Program) => {
        return new Promise<any>((resolve, reject) => {
            service.add(program)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const updateWebPage = (program: Program) => {
        return new Promise<any>((resolve, reject) => {
            service.update(program.id, program)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const getWebPageByType = (type: PageType) => {
        return new Promise<any>((resolve, reject) => {
            service.getByType(type)
                .then(({ data }) => {
                    data?.ok ? resolve(data) : resolve(undefined);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }




    return {
        getWebPageByType,
        getWebPage,
        addWebPage,
        updateWebPage

    };
};